module.exports = __webpack_public_path__ + "images/tips/info-image-02@2x.dc2ae20f9f00051bb6d4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-02@2x.png
// module id = AivZ
// module chunks = 13